/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import {
  Typography,
  TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

const messages = defineMessages({
  completion: {
    id: 'Elearning.completion',
    defaultMessage: '% Réussite',
  },
});

const renderTextField = ({
  input,
  label,
  ...custom
}) => (
  <TextField
    label={label}
    {...input}
    {...custom}

  />
);

const ElearningCompletion = (props) => {
  const { intl } = props;
  return (
    <>
      <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
        {intl.formatMessage(messages.completion)}
      </Typography>
      <Field
        name="elearningTarget"
        label={intl.formatMessage(messages.completion)}
        style={{ width: '100%' }}
        id="filled-number"
        variant="outlined"
        type="number"
        inputProps={{ min: '0', step: '5' }}
        component={renderTextField}
      />
    </>
  );
};

ElearningCompletion.propTypes = {
  intl: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return ({ initialValues: state.group.selectedGroup, form: name, dataform });
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,

})(injectIntl(ElearningCompletion));

const NewconnectedGroupForm = connect(mapStateToProps, {})(connectedGroupForm);

export default (NewconnectedGroupForm);
